	// javascript extension for lightbox images in Blog Area
	jQuery(document).ready(function($){
		//$('.articles').find('img').wrap('<a href="'+$(this).attr('src')+'" class="zoom" id="placeholder"></a>');
      	
      	$('.articles, .article').find('img').each(function () {
          
          //var big_img = $(this).attr('src').val(val.replace('_small', '_grande'));
          var big_img = $(this).attr('src').replace('_small', '_grande');
          big_img = big_img.replace('_medium', '_grande');
          big_img = big_img.replace('_compact', '_grande');
          big_img = big_img.replace('_large', '_grande');
          
          
          //var big_img = 'http://cdn.shopify.com/s/files/1/0266/9535/products/Catalina01_small.jpg?866';
          $(this).wrap('<a href="'+big_img+'" class="zoom" id="placeholder"></a>');
          
		});
      
      // Generate Groups for Fancybox Group Views
      $('.articles, .article').each(function () {
        	var ran_number = Math.floor(Math.random() * (100000 + 1));
        	$(this).find('.zoom').each(function () {
        		$(this).attr('rel','group'+ran_number);
      		});  
        	
      });
       
	});

